module.exports = __webpack_public_path__ + "media/images/mobile/Mask Group 11-2064d41fc9dc8d1fc2b0422c9a3e4d31.png";